var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.748 11.999C13.748 13.3249 12.7397 14.3998 11.4959 14.3998C10.2521 14.3998 9.24383 13.3249 9.24383 11.999C9.24383 10.673 10.2521 9.59809 11.4959 9.59809C12.7397 9.59808 13.748 10.673 13.748 11.999ZM11.5 7C10.2122 7.00636 8.87733 7.35521 7.6137 8.0231C6.67548 8.53943 5.76112 9.26791 4.96742 10.167C4.5776 10.626 4.08039 11.2906 4 11.9997C4.0095 12.614 4.60162 13.3721 4.96742 13.8324C5.71171 14.6963 6.60225 15.4044 7.6137 15.9769C8.79209 16.6132 10.0964 16.9796 11.5 17C12.789 16.9935 14.1236 16.6407 15.3858 15.9769C16.3241 15.4606 17.2389 14.7316 18.0326 13.8324C18.4224 13.3734 18.9196 12.7088 19 11.9997C18.9905 11.3855 18.3984 10.6273 18.0326 10.167C17.2883 9.30319 16.3973 8.5956 15.3858 8.02308C14.2081 7.38721 12.9005 7.02335 11.5 7ZM11.4991 8.24135C13.4505 8.24135 15.0325 9.92426 15.0325 12.0003C15.0325 14.0763 13.4505 15.7592 11.4991 15.7592C9.54756 15.7592 7.96561 14.0763 7.96561 12.0003C7.96561 9.92426 9.54756 8.24135 11.4991 8.24135Z",
    fill: "#C6CCFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreview);
export default __webpack_public_path__ + "static/media/preview.2120cef660f05b7c0cb4e6ca2acda8b6.svg";
export { ForwardRef as ReactComponent };